import { FormattedCategory } from './../../shared/dtos/formatted-category';
import { Algorithm } from './../../shared/dtos/algorithm';
import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService, itiMessageService } from '@/iti-core-vue';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'AlgorithmModule',
    store,
    dynamic: true,
})

class AlgorithmModule extends VuexModule {
    public algorithms: Algorithm[] = [];
    public selectedAlgorithm: Algorithm = new Algorithm();
    public idSelectedAlgorithm: number = 0;
    public formattedCategoriesList: FormattedCategory[] = [];
    public algorithmEditMode: boolean = false;
    public selectedAlgorithmEnvironmentVariables: any[] | null = [];


    @Mutation
    public setAlgorithms(algorithms: Algorithm[]) {
        this.algorithms = algorithms;
    }

    @Action
    public async getAlgorithms() {
        const res = await itiHttpService.get(API.algorithm);
        this.context.commit('setAlgorithms', res);
    }

    @Mutation
    public setAlgorithmById(algorithm: Algorithm) {
        this.selectedAlgorithm = new Algorithm(algorithm);
        this.selectedAlgorithmEnvironmentVariables = this.selectedAlgorithm.environmentArray();
    }
    @Mutation
    public newAlgorithm() {
        this.selectedAlgorithm = new Algorithm();
        this.selectedAlgorithmEnvironmentVariables = [];
    }

    @Action
    public async launchAlgorithms() {
        try {
            const url = API.algorithm + '/LaunchAlgorithms';
            const response = await itiHttpService.get(url, null, true, false, false);
        } catch (err) {
            return itiMessageService.TypeError;
        }
    }

    @Action
    public async getAlgorithmById(id: number) {
        if (id != null) {
            try {
                const response = await itiHttpService.get(ItiString.Format(API.algorithmDetail, id));
                this.context.commit('setAlgorithmById', response);
            } catch (err) {
                return itiMessageService.TypeError;
            }
        }
        else {
            this.context.commit('newAlgorithm');
        }
    }

    @Action
    public async saveAlgorithm(algorithm: Algorithm) {
        let res = null;
        algorithm.setEnvironmentVariablesFromArray(this.selectedAlgorithmEnvironmentVariables);
        if (algorithm.id == null) {
            algorithm.id = 0;
            res = await itiHttpService.post(API.algorithm, algorithm.toJson());
        } else {
            const algorithmDB: Algorithm = new Algorithm(algorithm);
            res = await itiHttpService.put(API.algorithm, algorithmDB.toJson());
        }
        this.context.commit('setAlgorithmById', res);
    }
    @Action
    public async deleteAlgorithm(algorithm: Algorithm) {
        if (algorithm.id != null) {
            const url = ItiString.Format(API.algorithmDetail, algorithm.id);
            const res = await itiHttpService.delete(url, null);
        }
        this.context.dispatch('getAlgorithms');
    }

    @Mutation
    public setFormattedCategories(formattedCategoriesList: FormattedCategory[]) {
        this.formattedCategoriesList = formattedCategoriesList;
    }

    @Action
    public async getFormattedCategories() {
        const res = await itiHttpService.get(API.formattedCategory);
        this.context.commit('setFormattedCategories', res);
    }
    @Mutation
    public setAlgorithmEditMode(editar: boolean) {
        this.algorithmEditMode = editar;
    }

    @Action
    public async register(algorithm: Algorithm) {
        const url = ItiString.Format(API.squidRegister, algorithm.id);
        const res = await itiHttpService.post(url, null);
        this.context.dispatch('getAlgorithms');
    }

    @Action
    public async unregister(algorithm: Algorithm) {
        const url = ItiString.Format(API.squidUnregister, algorithm.id);
        const res = await itiHttpService.post(url, null);
        this.context.dispatch('getAlgorithms');
    }

    @Action
    public async activate(algorithm: Algorithm) {
        const res = await itiHttpService.post(API.squidChangeStatus, { status: true, algorithmId: algorithm.id }, false);
        this.context.dispatch('getAlgorithms');
    }
    @Action
    public async deactivate(algorithm: Algorithm) {
        const res = await itiHttpService.post(API.squidChangeStatus, { status: false, algorithmId: algorithm.id }, false);
        this.context.dispatch('getAlgorithms');
    }

}

export default getModule(AlgorithmModule);